/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Auto_WrapInputs */

const en_live_caption_auto_wrap = /** @type {(inputs: Live_Caption_Auto_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-wrap when the character limit is reached`)
};

const fr_live_caption_auto_wrap = /** @type {(inputs: Live_Caption_Auto_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour à la ligne automatique lorsque la limite de caractères est atteinte`)
};

const de_live_caption_auto_wrap = /** @type {(inputs: Live_Caption_Auto_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatischer Zeilenumbruch bei Erreichen der Zeichengrenze`)
};

const it_live_caption_auto_wrap = /** @type {(inputs: Live_Caption_Auto_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andare a capo automaticamente al raggiungimento del limite di caratteri.`)
};

const ru_live_caption_auto_wrap = /** @type {(inputs: Live_Caption_Auto_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматический перенос символов при достижении лимита символов.`)
};

const es_live_caption_auto_wrap = /** @type {(inputs: Live_Caption_Auto_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar automáticamente el texto cuando se alcance el límite de caracteres.`)
};

const zh_cn2_live_caption_auto_wrap = /** @type {(inputs: Live_Caption_Auto_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`达到字符限制时自动换行`)
};

const ja_live_caption_auto_wrap = /** @type {(inputs: Live_Caption_Auto_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字数制限に達したら自動的に折り返す`)
};

const hi_live_caption_auto_wrap = /** @type {(inputs: Live_Caption_Auto_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अक्षर सीमा पूरी हो जाने पर स्वतः रैप हो जाएगा`)
};

const pt_pt2_live_caption_auto_wrap = /** @type {(inputs: Live_Caption_Auto_WrapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quebra automática de linha quando o limite de caracteres for atingido.`)
};

/**
* | output |
* | --- |
* | "Auto-wrap when the character limit is reached" |
*
* @param {Live_Caption_Auto_WrapInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_auto_wrap = /** @type {((inputs?: Live_Caption_Auto_WrapInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Auto_WrapInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_auto_wrap(inputs)
	if (locale === "de") return de_live_caption_auto_wrap(inputs)
	if (locale === "it") return it_live_caption_auto_wrap(inputs)
	if (locale === "ru") return ru_live_caption_auto_wrap(inputs)
	if (locale === "es") return es_live_caption_auto_wrap(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_auto_wrap(inputs)
	if (locale === "ja") return ja_live_caption_auto_wrap(inputs)
	if (locale === "hi") return hi_live_caption_auto_wrap(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_auto_wrap(inputs)
	return en_live_caption_auto_wrap(inputs)
});